import React from 'react';

import { useIntl } from 'react-intl';

import packageJson from '../../../package.json';

interface IFooterProps {
  /** Render in the page flow rather than pinned to the viewport bottom (the login surface). */
  inline?: boolean;
}

const Footer = ({ inline = false }: IFooterProps) => {
  const intl = useIntl();

  return (
    <>
      <div
        className={
          inline
            ? 'login-footer d-flex flex-column-reverse align-items-start mt-5 pt-4'
            : 'fixed-bottom d-flex align-items-center justify-content-center mb-3 flex-column'
        }
      >
        <div>
          <span className={inline ? 'login-copyright' : 'text-light text-sm'} data-test="copyright">
            {`${intl.formatMessage(
              { id: 'webCopyrightKey' },
              // A string, not a number: ICU would render the number 2026 as "2,026".
              { year: String(new Date().getFullYear()) }
            )} v${packageJson.version}`}
          </span>
        </div>
        <div className={inline ? 'd-flex flex-wrap gap-3 mb-2' : 'd-flex justify-content-around'}>
          <span
            className={inline ? 'cursor-pointer' : 'font-weight-light text-xs cursor-pointer mx-2'}
          >
            <a
              href="https://caresimple.com/terms-of-use/"
              target="_blank"
              rel="noreferrer"
              data-test="termsOfUse"
            >
              {intl.formatMessage({ id: 'termsOfUseKey' })}
            </a>
          </span>
          <span
            className={inline ? 'cursor-pointer' : 'font-weight-light text-xs cursor-pointer mx-2'}
          >
            <a
              href="https://caresimple.com/privacy-policy/"
              target="_blank"
              rel="noreferrer"
              data-test="privacyPolicy"
            >
              {intl.formatMessage({ id: 'privacyPolicyKey' })}
            </a>
          </span>
          <span
            className={inline ? 'cursor-pointer' : 'font-weight-light text-xs cursor-pointer mx-2'}
          >
            <a
              href="https://caresimple.com/compliance/"
              target="_blank"
              rel="noreferrer"
              data-test="intendedUse"
            >
              {intl.formatMessage({ id: 'intendedUseKey' })}
            </a>
          </span>
          <span
            className={inline ? 'cursor-pointer' : 'font-weight-light text-xs cursor-pointer mx-2'}
          >
            <a
              href="https://caresimple.com/open-source-software/"
              target="_blank"
              rel="noreferrer"
              data-test="thirdPartyNotices"
            >
              {intl.formatMessage({ id: 'thirdPartyNoticesKey' })}
            </a>
          </span>
        </div>
      </div>
    </>
  );
};

export default Footer;
